import classNames from 'classnames';
import React, { MouseEventHandler } from 'react';

const FoldedHandIcon = ({ onClick, className }: { className?: string; onClick?: MouseEventHandler<SVGSVGElement> }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='36'
      height='28'
      viewBox='0 0 140 120'
      className={classNames('cursor-pointer active:scale-95', className)}
      onClick={onClick}
    >
      <g transform='scale(0.9) translate(10 10)'>
        <path
          fill='#FFCA28'
          d='m102.8 89.9l-15.7 20.3s-14.6-8-18.4-10s-4.7-8.8-4.7-8.8s-.9 6.8-4.7 8.8s-18.4 10-18.4 10L25.2 89.9c5.4-2.5 8.7-5 10.9-6.8s4-4.8 4.8-7.8c.7-3 3.7-17.6 3.8-20s.8-5.4 2.3-7.8s2-6.6 3-11.8c1.7-9 3-13.5 3.3-15.7c.3-2.1.5-7.1.6-8.7c.1-1.4 1.7-3.2 4.3-3.3c4.1-.2 5.8 2.2 5.8 5.4c0-3.3 1.7-5.6 5.8-5.4c2.6.1 4.1 1.9 4.3 3.5c.1 1.6.3 6.6.6 8.7s1.6 6.7 3.3 15.7c1 5.2 1.6 9.5 3 11.8s2.2 5.4 2.3 7.8s3.1 17 3.8 20c.8 3 2.6 6 4.8 7.8c2.2 1.7 5.5 4.1 10.9 6.6'
        />
        <defs>
          <path
            id='SVG2NhGOecI'
            d='M102.8 89.9c-5.4-2.5-8.7-5-10.9-6.8s-4-4.8-4.8-7.8s-3.7-17.6-3.8-20s-.8-5.4-2.3-7.8c-1.4-2.4-2-6.6-3-11.8c-1.7-9-3-13.5-3.3-15.7c-.3-2.1-.5-7.1-.6-8.7c-.1-1.4-1.7-3.2-4.2-3.3c-4.1-.2-5.9 2.2-5.9 5.4v78.1s.9 6.8 4.7 8.8s18.4 10 18.4 10z'
          />
          <path
            id='SVGshosQdTq'
            d='M25.2 89.9c5.4-2.5 8.7-5 10.9-6.8s4-4.8 4.8-7.8c.7-3 3.7-17.6 3.8-20s.8-5.4 2.3-7.8c1.4-2.4 2-6.6 3-11.8c1.7-9 3-13.5 3.3-15.7c.3-2.1.5-7.1.6-8.7c.1-1.4 1.7-3.2 4.2-3.3c4.1-.2 5.9 2.2 5.9 5.4v78.1s-.9 6.8-4.7 8.8s-18.4 10-18.4 10z'
          />
        </defs>
        <clipPath id='SVGq1LijdRU'>
          <use href='#SVG2NhGOecI' />
        </clipPath>
        <g fill='#FAA700' clip-path='url(#SVGq1LijdRU)'>
          <path d='M102.8 93.5s-9-6.1-11.7-8.1c-2.7-1.9-5.8-5-6.4-8.7s-2.4-13.3-2.8-16.1c-.3-2.6-.5-5.7-1.1-8.4c-.4-1.9-2.3-3.8-2.8-7.1c-.4-3.3-4.1-21-4.1-21s-1.5-7.5-1.5-9.1c0-3-.3-5.8-3.8-6s-2.2-3.4-2.1-3.7c.2-.2 8.1 0 8.1 0l30.1 82.1zm-10 8.6S80 94.7 78.5 93.5c-3 .6-13.6.5-13.9-13.5H62l-.5 22.7L85.8 113z' />
        </g>
        <defs>
          <use href='#SVGshosQdTq' id='SVG12tw4gdi' />
        </defs>
        <clipPath id='SVGy1zrMc0K'>
          <use href='#SVG12tw4gdi' />
        </clipPath>
        <g fill='#FAA700' clip-path='url(#SVGy1zrMc0K)'>
          <path d='M25.2 93.5s9-6.1 11.7-8.1c2.7-1.9 5.8-5 6.4-8.7s2.4-13.3 2.8-16.1c.3-2.6.5-5.7 1.1-8.4c.4-1.9 2.3-3.8 2.8-7.1c.4-3.3 4.1-21 4.1-21s1.5-7.5 1.5-9.1c0-3 .3-5.8 3.8-6s2.2-3.4 2.1-3.7s-8.1 0-8.1 0L23.2 87.5zm10 8.6s12.8-7.4 14.3-8.6c3 .6 13.6.5 13.9-13.5H66l.5 22.7L42.2 113z' />
        </g>
        <defs>
          <use href='#SVG2NhGOecI' id='SVGRGP6fd9J' />
        </defs>
        <clipPath id='SVGY6ym8cFb'>
          <use href='#SVGRGP6fd9J' />
        </clipPath>
        <path
          fill='#B55E19'
          d='M72.8 9.1c-2.6-.7-6.5-.6-6.5 6.1c2.1-2.7 7.7-1.8 8.3 3.3c.4 3.6 6.8 28.3 6.8 28.3s-2.8 1-3.2-.9s-4.5-21.3-4.8-22.9c-.4-1.6-.5-4-.9-4.8c-1.4-3.6-6.4-2-6.5.7c-.1 3.8-.1 7.7-.1 9.8c1.7-2.3 4.7-2.1 5.9-1.3c1.1.7 1.8 1.9 1.9 2.7c.8 5 1.8 12.3 2.1 14.3s1.2 5.2 1.7 6.8c.5 1.7 1.7 5.8 1.8 8c0 1.7-1.8 1.4-1.9.2c-.2-2.7-1.6-7.2-2.1-8.9s-1.4-5.3-1.8-8.9c-.4-3.5-1.1-8.1-1.4-9.8c-.7-3.8-6-3.3-6.3.1c-.3 2.7-.6 5.6.2 9.9c.5 2.6 1 10.2-.4 14.7c-.6 1.8-.7 5.4-.7 7.7c0 2.2-.2 25.5-.2 26.3s-.7.6-.7.6h-1.7l.6-84.3l10.3-.3c.1 0 2.2 3.3-.4 2.6'
          clip-path='url(#SVGY6ym8cFb)'
        />
        <defs />
        <path
          fill='#B55E19'
          d='M55.2 9.1c2.6-.7 6.5-.6 6.5 6.1c-2.1-2.7-7.7-1.8-8.3 3.3c-.4 3.6-6.8 28.3-6.8 28.3s2.8 1 3.2-.9s4.5-21.3 4.8-22.9c.4-1.6.5-4 .9-4.8c1.4-3.6 6.4-2 6.5.7c.1 3.8.1 7.7.1 9.8c-1.7-2.3-4.7-2.1-5.9-1.3c-1.1.7-1.8 1.9-1.9 2.7c-.8 5-1.8 12.3-2.1 14.3s-1.2 5.2-1.7 6.8s-1.7 5.8-1.8 8c0 1.7 1.8 1.4 1.9.2c.2-2.7 1.6-7.2 2.1-8.9s1.4-5.3 1.8-8.9c.4-3.5 1.1-8.1 1.4-9.8c.7-3.8 6-3.3 6.3.1c.3 2.7.6 5.6-.2 9.9c-.5 2.6-1 10.2.4 14.7c.6 1.8.7 5.4.7 7.7c0 2.2.2 25.5.2 26.3c0 .7.7.7.7.7h1.7l-.6-84.4l-10.4-.3s-2.1 3.3.5 2.6'
          clip-path='url(#SVGy1zrMc0K)'
        />
        <path
          fill='#2686C6'
          d='M114.9 94.4c-4.5-1.7-10.1-5.5-11.8-6.7s-2.7-.2-3 .5c-4.1 7.7-13.6 18.2-18.5 23.3c-.9.9-.4 2.2 0 2.6s11.6 10.1 11.6 10.1s14.3-9.6 21.7-29.8m-101.8 0c4.5-1.7 10.1-5.5 11.8-6.7s2.7-.2 3 .5c4.1 7.7 13.6 18.2 18.5 23.3c.9.9.4 2.2 0 2.6s-11.6 10.1-11.6 10.1s-14.3-9.6-21.7-29.8'
        />
      </g>
    </svg>
  );
};

export default FoldedHandIcon;
